import get from 'lodash.get'

const isIsoDate = (potentialDate: string): boolean => {
  if (!/\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}.\d{3}Z/.test(potentialDate))
    return false
  try {
    var d = new Date(potentialDate)
    return d.toISOString() === potentialDate
  } catch (err) {
    return false
  }
}

const isValidDate = (d: Date) => {
  //@ts-ignore
  return d instanceof Date && !isNaN(d)
}

const parsers = {
  date: (value: Date) => value.getTime().toString(),
}

export const compileTemplate = <T extends object>(
  template: string,
  context: T,
  hooks?: {
    onCastedValue?: (input: { originalValue: any; castedValue: any }) => any
  },
) => {
  const regex = /{{\s*([^{}]+)\s*}}/g

  return template.replace(regex, (_, match) => {
    const originalValue = get(context, match)

    const processValue = () => {
      //@ts-ignore
      if (
        originalValue &&
        typeof originalValue === 'object' &&
        //@ts-ignore
        originalValue instanceof Date
      ) {
        if (hooks?.onCastedValue)
          hooks.onCastedValue({
            originalValue: originalValue.toString(),
            castedValue: originalValue,
          })

        return parsers.date(originalValue)
      }

      if (
        originalValue &&
        isIsoDate(originalValue) &&
        isValidDate(new Date(originalValue))
      ) {
        const castedValue = new Date(originalValue)

        if (hooks?.onCastedValue)
          hooks.onCastedValue({
            originalValue,
            castedValue,
          })

        return parsers.date(castedValue)
      }

      const castedValue = originalValue ? String(originalValue) : ''

      if (hooks?.onCastedValue)
        hooks.onCastedValue({
          originalValue,
          castedValue,
        })

      return castedValue
    }

    const value = processValue()

    return value
  })
}
